export default {
  auth: '/api/v1/identity/login',
  logout: '/api/v1/identity/logout',
  emailVerification: '/api/v1/identity/verify',
  accountActivation: '/api/v1/identity/activate',
  ownUserInfo: '/api/v1/identity/whoami',

  driverList: '/api/v1/orders/driver/filter',
  driverDetail: '/api/v1/orders/driver',
  driverActivation: '/api/v1/orders/driver/active-deactive',
  driverDelete: '/api/v1/orders/driver',

  transportTypeList: '/api/v1/orders/contracts/vehicles',
  transportList: '/api/v1/orders/transports/filter',
  transportDetail: '/api/v1/orders/transports',
  transportActivation: '/api/v1/orders/transports/active-deactive',

  locationList: '/api/v1/orders/locations/filter',

  shipmentGroupList: '/api/v1/orders/shipments/group/filter',
  shipmentGroupDetail: '/api/v1/orders/shipments/group',
  orderList: '/api/v1/orders/shipments/filter',
  orderDetail: '/api/v1/orders/shipments',
  orderStatusHistory: (orderId) => `/api/v1/delivery/shipments/${orderId}/status-history`,
  orderSummary: '/api/v1/orders/shipments/summary',
  orderSchedule: '/api/v1/orders/shipments/calendar',
  orderQuantity: '/api/v1/orders/shipments/action/quantity-info',
  orderDocuments: (orderId, type) => `/api/v1/orders/shipments/${orderId}/document/${type}`,
  orderDocumentCompletion: '/api/v1/orders/shipments/action/document-mark',
  orderCalculatedQuantity: '/api/v1/orders/calculate-cost',
  orderContractUnitOptions: '/api/v1/orders/contracts/unit',
  orderListPageSizes: '/api/v1/orders/parameter/pagination',

  transactionList: '/api/v1/transaction/shipments/transporter/filter',
  transaction: '/api/v1/transaction',
  invoiceList: '/api/v1/transaction/invoice/filter',
  invoiceStatus: '/api/v1/transaction/invoice/status',
  invoiceDetail1: '/api/v1/transaction/invoice/detail-1',
  invoiceDetail2: '/api/v1/transaction/invoice/detail-2',
  invoiceCommonData: '/api/v1/transaction/common/data/invoice',
  invoiceEditTransactionList: '/api/v1/transaction/list/proforma/transporter',
  invoice: '/api/v1/transaction/invoice',
  createInvoice: '/api/v1/transaction/invoice/transporter',
  emailInvoice: '/api/v1/transaction/invoice/email',
  resubmitToOracle: '/api/v1/transaction/invoice/resubmit/oracle',

  availableTransports: (orderId, transporterId) => `/api/v1/orders/shipments/${orderId}/${transporterId}/transport/available`,
  availableDrivers: (orderId, transporterId) => `/api/v1/orders/shipments/${orderId}/${transporterId}/driver/available`,
  assignTransport: '/api/v1/orders/shipments/action/confirm',
  reassignTransport: '/api/v1/orders/shipments/action/reassign/transport-driver',
  uploadImage: '/api/v1/image-upload',
  uploadCsv: '/api/v1/orders/upload/csv',
  uploadedCsvStatus: 'api/v1/orders/upload/filter',
  uploadedCsvDetail: 'api/v1/orders/upload/detail',
  csvTemplateData: '/api/v1/orders/upload/template',

  selectionInfoFilter: '/api/v1/orders/selection-info/filter',

  userDetail: '/api/v1/identity/users',
  userList: '/api/v1/identity/users/filter',
  userActivation: '/api/v1/identity/users/active-deactive',
  userResetPassword: '/api/v1/identity/users/reset',

  notification: '/api/v1/identity/notifications',
  notificationList: '/api/v1/identity/notifications/filter',
  notificationUnreadCount: '/api/v1/identity/notifications/counter',

  shipmentAccidentList: '/api/v1/orders/shipments/accident/filter',
  newAccidentCount: '/api/v1/orders/shipments/accident/counter',
  processProblem: '/api/v1/orders/shipments/accident/proceed',
  resolveProblem: '/api/v1/orders/shipments/accident/resolve',
  shipmentProblemLastLoc: '/api/v1/orders/shipments/accident/location',
  shipmentProblem: '/api/v1/orders/shipments/accident/detail',

  damagedAndMissingList: '/api/v1/orders/shipments/damage/filter',
  damagedAndMissingDetail: '/api/v1/orders/shipments/damage/detail',

  clientList: '/api/v1/identity/clients/filter',

  getAgingReport: '/api/v1/transaction/report/invoice/aging/transporter',
  getIncomeReport: '/api/v1/transaction/report/invoice/income/transporter',
  getTaxRecap: 'api/v1/transaction/report/invoice/rekap2',
  getDataArmadaReport: 'api/v1/orders/report/transport/transporter',
  getProblemArmadaReport: 'api/v1/orders/report/accident/transporter',
  getOrderShipperReport: 'api/v1/orders/report/shipment/transporter',
  getListBasp: 'api/v1/orders/report/basp/transporter',
  locationsFromOrders: '/api/v1/orders/shipments/transaction/location/filter',
  vehiclesFromOrders: '/api/v1/orders/shipments/transaction/vehicle/filter',
}
